/** Phone: 7–15 digits; required + or 00 country-code prefix; digits, dots, spaces, hyphens. */
export const EXTERNAL_REFERRAL_PHONE_REGEX =
  /^(?=(?:\D*\d){7,15}\D*$)(?:\+|00)\d[\d.\s-]*$/;

/** Light email shape check (aligned with referral-common.service). */
export const EXTERNAL_REFERRAL_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EXTERNAL_REFERRAL_PARTICIPANT_NAME_MAX_LENGTH = 100;

/** Max length for persisted manual external referral source (DB + DTO + zod). */
export const EXTERNAL_REFERRAL_SOURCE_MAX_LENGTH = 255;
